import { toAbsoluteIso, type TimeSlot } from "#/modules/les.planning/domain/calendar";
import type { components } from "#/schema";
import type { CalendarDate } from "@internationalized/date";

export type LesplanningLes = components["schemas"]["LesplanningLesModel"];
export type SociaalEmotioneelDomein = components["schemas"]["SociaalEmotioneelDomein"];
export interface Lesplanning {
  readonly lessen: LesplanningLes[];
}

export type LesTimeStatus = "gepland" | "gemist" | "actief" | "afgerond";

export const DEFAULT_DURATION_MINUTES = 45;

export interface PlanningRange {
  readonly from: string;
  readonly to: string;
}

export const getPlanningRange = (weekStart: CalendarDate, timeZone?: string): PlanningRange => ({
  from: toAbsoluteIso(weekStart, 0, timeZone),
  to: toAbsoluteIso(weekStart.add({ days: 7 }), 0, timeZone),
});

export const getLesTimeStatus = (
  les: Pick<LesplanningLes, "status" | "startAt" | "duurMinuten">,
  now: Date,
): LesTimeStatus => {
  if (les.status === "Afgerond") return "afgerond";
  if (les.status === "Actief") return "actief";
  const end = new Date(les.startAt).getTime() + les.duurMinuten * 60_000;
  return end < now.getTime() ? "gemist" : "gepland";
};

/** Lessen started without a schedule are stored at midnight; they have no place in a lesuur. */
export const isWithoutTime = (slot: Pick<TimeSlot, "startMinutes">): boolean =>
  slot.startMinutes === 0;

/** A les still to come is prepared and moved by whoever opens it, a colleague's as well. */
export const canEditLes = (les: LesplanningLes): boolean => les.status === "Concept";
